import type { AvailableFilterOption } from "../map/types";
export interface Input {
  options: AvailableFilterOption[];
  "on-option-change": (e: { checked: boolean; value: string }) => void;
}
$ const { options } = input;

<div class="filter-condition-dialog__form">
  <fieldset class="filter-condition-dialog__form__input">
    <for|option| of=options>
      <span class="filter-condition-dialog__form__checkbox">
        <ebay-checkbox
          on-change("emit", "option-change")
          id=`filter-condition-dialog-checkbox-${option.fieldId}`
          data-testid=`filter-condition-dialog-checkbox-${option.fieldId}`
          value=option.fieldId
          name="filter-condition-checkbox"
          checked=option.isEnabled
          size="large"
        />
        <label for=`filter-condition-dialog-checkbox-${option.fieldId}`>
          ${option.label}
        </label>
      </span>
    </for>
  </fieldset>
</div>
